import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精选51大赛专题内容推荐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item, index) => (
            <div
              key={index}
              className="group relative bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all duration-200 flex flex-col"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={`51大赛 ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-semibold rounded-full bg-accent-500 text-background-50">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-base md:text-lg font-bold text-foreground-950 leading-snug">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{item.description}</p>
                <div className="mt-4 flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}